import AdminCrudPage from "./AdminCrudPage";

export default function AdminRedirects() {
  return <AdminCrudPage title="Page Redirects" endpoint="redirects" testIdPrefix="redirects"
    columns={[
      { key: "label", label: "Label" },
      { key: "source_path", label: "Source" },
      { key: "destination_url", label: "Destination", render: (i) => (
        <span className="text-xs text-neutral-600 truncate max-w-xs inline-block">{i.destination_url}</span>
      ) },
      { key: "mode", label: "Mode" },
      { key: "enabled", label: "Enabled", render: (i) => i.enabled ? "Yes" : "No" },
    ]}
    fields={[
      { name: "key", label: "Key (unique, url-friendly)", type: "text", required: true, placeholder: "privacy" },
      { name: "label", label: "Display label", type: "text", required: true, placeholder: "Privacy Policy" },
      { name: "source_path", label: "Source path (on this site)", type: "text", required: true, placeholder: "/privacy" },
      { name: "destination_url", label: "Destination URL (external) or route", type: "text", required: true, placeholder: "https://..." },
      { name: "mode", label: "Mode", type: "select", options: ["external", "internal_cms"], default: "external" },
      { name: "redirect_type", label: "HTTP redirect type", type: "select", options: ["301", "302"], default: "302" },
      { name: "open_new_tab", label: "Open in new tab", type: "checkbox" },
      { name: "enabled", label: "Enabled", type: "checkbox", default: true },
      { name: "show_in_footer", label: "Show in footer", type: "checkbox", default: true },
      { name: "footer_order", label: "Footer order", type: "number", default: 0 },
      { name: "footer_row", label: "Footer row (1 or 2)", type: "number", default: 1 },
    ]}
  />;
}
